import Cookies from 'js-cookie';
import * as React from 'react';

import { trackWidgetStep } from '@sorpetaler/ui/src/utils/helpers';
import { Button } from '@sorpetaler/ui/src/components/Clickable';
import {
  AmountOfWindows,
  Material,
  PersonalInformation,
  ShippingDate,
} from '../FensterTurenWidget';
import * as styles from '../FensterTurenWidget/FensterTurenWidget.module.less';
import { WidgetFormQuote } from '../WidgetFormQuote';
import { WidgetSteps } from '@sorpetaler/ui/src/components/WidgetSteps';
import { WidgetSuccessMessage } from '@sorpetaler/ui/src/components/WidgetSuccessMessage';

import { Opening, Resistance } from '.';

export const BrandschutzWidget: React.FunctionComponent = () => {
  const [windowsMaterial, setWindowsMaterial] = React.useState('');
  const [resistanceDegree, setResistanceDegree] = React.useState('');
  const [glazingBars, setGlazingBars] = React.useState('');
  const [numberOfWindows, setNumberOfWindows] = React.useState(2);
  const [executionPeriod, setExecutionPeriod] = React.useState('');
  const [activeStep, setActiveStep] = React.useState(1);
  const [submitted, setSubmitted] = React.useState(false);

  React.useEffect(() => {
    trackWidgetStep('brandschutz', activeStep);
    window.location.hash = `step${activeStep}`;
  }, [activeStep]);

  const numberOfSteps = 5;

  const windowSteps = {
    1: windowsMaterial,
    2: resistanceDegree,
    3: glazingBars,
    4: numberOfWindows,
    5: executionPeriod,
  };

  const windowsScreens = {
    1: (
      <Material
        text="Aus welchem Material sollen Ihre Brandschutzfenster bestehen?"
        onSelect={setWindowsMaterial}
        selectedItem={windowsMaterial}
      />
    ),
    2: (
      <Resistance
        onSelect={setResistanceDegree}
        selectedItem={resistanceDegree}
      />
    ),
    3: <Opening onSelect={setGlazingBars} selectedItem={glazingBars} />,
    4: (
      <AmountOfWindows
        product="Fenster"
        value={numberOfWindows}
        onValueChange={setNumberOfWindows}
      />
    ),
    5: (
      <ShippingDate
        product="Fenster"
        onSelect={setExecutionPeriod}
        selectedItem={executionPeriod}
      />
    ),
  };

  const listOfChoices = [
    { name: 'Material', value: windowsMaterial },
    { name: 'Widerstandsklasse', value: resistanceDegree },
    { name: 'Öffnung', value: glazingBars },
    { name: 'Anzahl der Fenster', value: numberOfWindows },
    { name: 'Ausführungszeitraum', value: executionPeriod },
  ];

  const handleFinish = (values) => {
    fetch('/.netlify/functions/SubmitWidget', {
      method: 'POST',
      body: JSON.stringify({
        ...values,
        formName: 'brandschutzfenster',
        gclid: Cookies.get('gclid'),
        details: listOfChoices.reduce((acc, curr) => {
          const key = curr.name === 'Anzahl der Fenster' ? 'Anzahl' : curr.name;
          return {
            ...acc,
            [key]: curr.value,
          };
        }, {}),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.statusText);
        } else {
          setSubmitted(true);
          return res;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const formSection = (
    <PersonalInformation
      onFormSubmit={handleFinish}
      listOfChoices={listOfChoices}
      showCompanyField
    />
  );

  const showPrevButton = activeStep !== 1;
  const showNextButton = activeStep <= numberOfSteps;

  const buttonsBlock = (
    <div className={styles.buttonsBlock}>
      {showPrevButton && (
        <Button
          variant="secondary"
          onClick={() => {
            setActiveStep((currentStep) => currentStep - 1);
          }}
        >
          Zurück
        </Button>
      )}
      {showNextButton && (
        <Button
          variant="primary"
          onClick={() => {
            const stepValue = windowSteps[activeStep];

            if (!stepValue) return;

            setActiveStep((currentStep) => currentStep + 1);
          }}
        >
          Weiter
        </Button>
      )}
    </div>
  );

  return (
    <section
      className={`${styles.container} ${
        activeStep == 6 ? styles.fullWidth : ''
      }`}
    >
      <div>
        {submitted ? (
          <WidgetSuccessMessage />
        ) : (
          <>
            {activeStep !== 6 && (
              <WidgetSteps
                activeStep={activeStep}
                numberOfSteps={numberOfSteps}
              />
            )}
            {windowsScreens[activeStep]}
            {activeStep === 6 && formSection}
            {activeStep !== 6 && buttonsBlock}
          </>
        )}
      </div>
      {activeStep == 6 && <WidgetFormQuote />}
    </section>
  );
};
